import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import { useAuth } from "@/lib/auth";
import Navbar from "@/components/Navbar";
import WhatsAppFab from "@/components/WhatsAppFab";
import { ArrowRight } from "@phosphor-icons/react";

export default function Login() {
    const { login } = useAuth();
    const nav = useNavigate();
    const loc = useLocation();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);

    async function submit(e) {
        e.preventDefault();
        setError("");
        setLoading(true);
        const r = await login(email, password);
        setLoading(false);
        if (r.ok) {
            const redirect = loc.state?.from || "/dashboard";
            nav(redirect);
        } else {
            setError(r.error);
        }
    }

    return (
        <div className="min-h-screen flex flex-col">
            <Navbar />
            <div className="flex-1 flex items-center justify-center px-6 py-16">
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    className="w-full max-w-md"
                >
                    <div className="gf-card">
                        <div className="micro-label mb-2">— Acceso</div>
                        <h1 className="serif text-3xl mb-2">Bienvenido de vuelta</h1>
                        <p className="text-sm text-[var(--gf-text-secondary)] mb-8">
                            Accede a tu panel para continuar con tus análisis financieros.
                        </p>

                        <form onSubmit={submit} className="space-y-5" data-testid="login-form">
                            <div>
                                <label className="gf-label">Email</label>
                                <input type="email" required className="gf-input" value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    data-testid="login-email" autoComplete="email" />
                            </div>
                            <div>
                                <label className="gf-label">Contraseña</label>
                                <input type="password" required className="gf-input" value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    data-testid="login-password" autoComplete="current-password" />
                            </div>
                            {error && (
                                <div className="text-sm text-[var(--gf-danger)] border-l-2 border-[var(--gf-danger)] pl-3 py-2 bg-red-50" data-testid="login-error">
                                    {error}
                                </div>
                            )}
                            <button type="submit" disabled={loading} className="btn-primary w-full justify-center" data-testid="login-submit">
                                {loading ? "Accediendo..." : "Acceder"} <ArrowRight size={16} />
                            </button>
                        </form>

                        <div className="mt-5 flex items-center gap-3">
                            <div className="flex-1 h-px bg-[var(--gf-border)]" />
                            <span className="text-xs text-[var(--gf-text-muted)] uppercase tracking-widest">o</span>
                            <div className="flex-1 h-px bg-[var(--gf-border)]" />
                        </div>
                        <button
                            type="button"
                            onClick={() => {
                                // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
                                const redirectUrl = window.location.origin + "/dashboard";
                                window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
                            }}
                            className="mt-4 w-full flex items-center justify-center gap-3 border border-[var(--gf-border)] bg-white hover:bg-[var(--gf-subtle)] py-3 px-4 transition-colors"
                            data-testid="login-google"
                        >
                            <svg width="18" height="18" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg"><path fill="#4285F4" d="M17.64 9.2c0-.637-.057-1.251-.164-1.84H9v3.481h4.844a4.14 4.14 0 0 1-1.796 2.716v2.259h2.908c1.702-1.567 2.684-3.874 2.684-6.615z"/><path fill="#34A853" d="M9 18c2.43 0 4.467-.806 5.956-2.184l-2.908-2.259c-.806.54-1.837.86-3.048.86-2.344 0-4.328-1.584-5.036-3.711H.957v2.332A8.997 8.997 0 0 0 9 18z"/><path fill="#FBBC05" d="M3.964 10.706A5.41 5.41 0 0 1 3.682 9c0-.593.102-1.17.282-1.706V4.962H.957A8.996 8.996 0 0 0 0 9c0 1.452.348 2.827.957 4.038l3.007-2.332z"/><path fill="#EA4335" d="M9 3.58c1.321 0 2.508.454 3.44 1.345l2.582-2.58C13.463.891 11.426 0 9 0A8.997 8.997 0 0 0 .957 4.962L3.964 7.294C4.672 5.167 6.656 3.58 9 3.58z"/></svg>
                            <span className="text-sm font-medium text-[var(--gf-navy)]">Continuar con Google</span>
                        </button>

                        <div className="mt-6 text-center text-sm text-[var(--gf-text-secondary)]">
                            ¿No tienes cuenta?{" "}
                            <Link to="/registro" className="text-[var(--gf-gold)] font-medium hover:underline" data-testid="to-register">
                                Regístrate
                            </Link>
                        </div>
                        <div className="mt-2 text-center text-sm">
                            <Link to="/recuperar-contrasena" className="text-[var(--gf-text-secondary)] hover:text-[var(--gf-gold)]" data-testid="to-forgot">
                                ¿Olvidaste tu contraseña?
                            </Link>
                        </div>
                    </div>
                </motion.div>
            </div>
            <WhatsAppFab />
        </div>
    );
}
